import { AppointmentAdvancePaymentEnableCustomRefundCommand } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';

type AppointmentAdvancePaymentEnableCustomRefundActionEventInterceptorProps = Readonly<{
   appointmentId: number;
   children: JSX.Element;
}>;

export const AppointmentAdvancePaymentEnableCustomRefundActionEventInterceptor = (
   props: AppointmentAdvancePaymentEnableCustomRefundActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: enableAdvancePaymentEnableCustomRefund } = useCqrsCommand<void, void>(() => {
      const command = new AppointmentAdvancePaymentEnableCustomRefundCommand();
      command.appointmentId = AppointmentId.of(props.appointmentId);
      return command;
   });

   return (
      <ActionEventInterceptor action={enableAdvancePaymentEnableCustomRefund}>{props.children}</ActionEventInterceptor>
   );
};
